
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinboshari() {



    const cardData =
    {
        keyword: 'Cab Service in Bhosari',
        heading: 'Platinum24 Cabs: Cab Service in Bhosari',
        headingDescription: ' Platinum24 Cabs provides trusted Cab Service in Bhosari, catering to both local and outstation travel needs. Whether you need a quick city drop, daily office commute, airport transfer, or a long-distance trip, our fleet of hatchbacks, sedans, SUVs, and luxury cars ensures a comfortable and safe journey. With professional drivers, clean vehicles, and transparent pricing, we deliver reliable service that suits every traveler’s budget. From solo passengers to family groups and corporate clients, Platinum24 Cabs guarantees punctuality, safety, and stress-free rides across Bhosari and nearby areas.',

        top: 'Top Places to Visit in Mumbai with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "Built in 1924, the Gateway of India is Mumbai’s most iconic landmark overlooking the Arabian Sea. Designed in Indo-Saracenic style, it commemorates the visit of King George V and Queen Mary. Visitors enjoy ferry rides to Elephanta Caves from here. The monument glows beautifully at night, attracting photographers and tourists alike. Surrounded by luxury hotels and local vendors, it is Mumbai’s proud welcoming arch."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive, stretching 3.6 km along the coast, is famously known as the Queen’s Necklace. Its sea-facing promenade is perfect for evening walks, sunsets, and relaxation. At night, the arc-shaped lights resemble a glowing necklace. Street food stalls serve bhel puri and pav bhaji, adding flavor to the visit. Families, couples, and joggers gather here daily. Marine Drive is Mumbai’s most scenic urban escape."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
    "description": "CSMT, a UNESCO World Heritage Site, is a masterpiece of Victorian Gothic architecture built in 1887. It is one of India’s busiest railway stations, blending Indian and European design. The grand domes, stained glass, and carvings make it breathtaking. At night, the illuminated façade adds magic. It is a cultural and functional landmark of Mumbai. CSMT is the city’s architectural pride."
  },
  {
    "title": "Elephanta Caves",
    "description": "Located on Elephanta Island, these 5th–6th century caves are dedicated to Lord Shiva. The highlight is the massive Trimurti sculpture, depicting Shiva in three forms. Visitors take ferries from the Gateway of India to reach here. Surrounded by greenery and sea views, it offers a blend of heritage and nature. A UNESCO World Heritage Site, it fascinates historians and tourists alike. Elephanta Caves are Mumbai’s cultural treasure."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah, built in Indo-Islamic style, stands on an islet in the Arabian Sea. It houses the tomb of Saint Pir Haji Ali Shah Bukhari. The walkway leading to the shrine gets submerged during high tide, adding mystique. People of all faiths visit to seek blessings. Evening qawwalis make the experience soulful. Haji Ali is Mumbai’s symbol of faith and harmony."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Siddhivinayak Temple in Prabhadevi is Mumbai’s most famous temple dedicated to Lord Ganesha. Its golden dome and intricately adorned idol attract thousands of devotees daily. Bollywood celebrities and politicians often visit for blessings. Tuesdays and Ganesh Chaturthi are especially crowded. Devotees believe prayers here bring success and prosperity. Siddhivinayak is Mumbai’s divine spiritual hub."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is Mumbai’s lively seaside attraction, known for its vibrant street food culture. Visitors relish pav bhaji, bhel puri, and kulfi while enjoying sea breezes. Sunsets here are spectacular and photogenic. Many Bollywood stars live nearby, adding glamour. Families and tourists flock daily for leisure and fun. Juhu Beach is Mumbai’s most popular coastal retreat."
  },
  {
    "title": "Colaba Causeway",
    "description": "Colaba Causeway is Mumbai’s bustling shopping street lined with stalls, boutiques, and cafes. Tourists bargain for jewelry, clothes, handicrafts, and antiques. Iconic cafes like Leopold and Mondegar add charm to the experience. The market reflects Mumbai’s cosmopolitan lifestyle. It is always buzzing with locals and foreigners. Colaba Causeway is Mumbai’s colorful shopping paradise."
  },
  {
    "title": "Film City",
    "description": "Film City in Goregaon is the hub of Bollywood, spread across 500 acres. It features studios, sets, and shooting locations where countless films and serials are made. Visitors can take guided tours to witness live shooting. From rural backdrops to grand palaces, Film City recreates it all. It is a dream come true for cinema lovers. Film City is Mumbai’s reel-world experience."
  },
  {
    "title": "Girgaon Chowpatty",
    "description": "Girgaon Chowpatty is famous for Ganesh Visarjan celebrations and Mumbai’s street food culture. In the evenings, the beach buzzes with stalls selling sev puri, pani puri, and falooda. Festivals and fairs make it vibrant throughout the year. Families enjoy walks along the shore as the sun sets. It offers a mix of tradition, leisure, and flavor. Chowpatty is Mumbai’s cultural seaside hotspot."
  }
],


   "services": [
    {
      "name": "Bhosari Cab Service",
      "description": "Get around Bhosari comfortably with our reliable Bhosari Cab Service. Whether for daily commutes or quick errands, our clean and well-maintained cabs are available at affordable rates with professional drivers."
    },
    {
      "name": "Taxi Service Bhosari",
      "description": "Book a trusted Taxi Service in Bhosari for all your local and outstation travel needs. We offer safe rides, on-time pickups, and a fleet of cars suited for every budget and group size."
    },
    {
      "name": "Bhosari Local Taxi",
      "description": "Our Bhosari Local Taxi service is ideal for quick rides within the city. Enjoy fast pickups, courteous drivers, and economical fares, perfect for shopping, appointments, or short trips."
    },
    {
      "name": "Affordable Taxi Bhosari",
      "description": "Looking for budget travel? Our Affordable Taxi Bhosari option offers pocket-friendly fares without compromising on comfort or service quality. Choose from multiple vehicle types as per your needs."
    },
    {
      "name": "Bhosari Taxi with Driver",
      "description": "Relax while we drive! Our Bhosari Taxi with Driver service offers trained, courteous chauffeurs familiar with local routes. Ideal for business, family, or elderly travelers seeking stress-free rides."
    },
    {
      "name": "Bhosari Airport Taxi",
      "description": "Catch your flight on time with our Bhosari Airport Taxi service. We provide punctual pickups and drop-offs to Pune Airport and nearby terminals with real-time tracking and fixed fares."
    },
    {
      "name": "Cab Rental Bhosari",
      "description": "Need a cab for a few hours or the whole day? Our Cab Rental Bhosari service offers flexible hourly or daily rental plans with or without drivers. Perfect for personal or corporate use."
    },
    {
      "name": "Bhosari Outstation Taxi",
      "description": "Plan your outstation trip with our Bhosari Outstation Taxi. Whether it’s a weekend getaway or a business visit, our clean, comfortable cars and experienced drivers ensure a smooth journey."
    },
    {
      "name": "Bhosari Corporate Taxi",
      "description": "Our Bhosari Corporate Taxi service caters to business professionals and companies needing regular employee travel, client pickups, or executive cars. Monthly billing and GST invoicing available."
    },
    {
      "name": "Bhosari Taxi Deals",
      "description": "Save more with exclusive Bhosari Taxi Deals! Enjoy discounts on round trips, early bookings, and referral offers. Affordable pricing with no hidden charges — just value-packed travel."
    },
    {
      "name": "Bhosari City Taxi",
      "description": "Navigate the city with ease using our Bhosari City Taxi service. Available for short city rides or full-day usage, our taxis come with trained drivers and GPS-enabled vehicles for safety."
    },
    {
      "name": "Bhosari Family Taxi Service",
      "description": "Travel together with our Bhosari Family Taxi Service. Spacious vehicles and friendly drivers make it ideal for family outings, functions, and sightseeing. Child seats available on request."
    },
    {
      "name": "Taxi Booking Online Bhosari",
      "description": "Book your ride in seconds with Taxi Booking Online Bhosari. Our platform allows instant booking, vehicle selection, and secure payment options with 24/7 support for any assistance."
    },
    {
      "name": "Bhosari Taxi Service 24x7",
      "description": "Need a taxi anytime? Our Bhosari Taxi Service 24x7 ensures you get a ride — day or night. Perfect for emergencies, airport transfers, or early-morning trips with fast response times."
    }
  ],
  "tableData": [
    ["Bhosari Cab Service", "Taxi Service Bhosari"],
    ["Bhosari Local Taxi", "Affordable Taxi Bhosari"],
    ["Bhosari Taxi with Driver", "Bhosari Airport Taxi"],
    ["Cab Rental Bhosari", "Bhosari Outstation Taxi"],
    ["Bhosari Corporate Taxi", "Bhosari Taxi Deals"],
    ["Bhosari City Taxi", "Bhosari Family Taxi Service"],
    ["Taxi Booking Online Bhosari", "Bhosari Taxi Service 24x7"]
  ],


   "whychoose": [
  {
    "WhyChooseheading": "Trusted Cab Service in Bhosari",
    "WhyChoosedescription": "Platinum24 Cabs provides reliable and affordable cab services in Bhosari to meet all your local travel needs."
  },
  {
    "WhyChooseheading": "Wide Range of Well-Maintained Vehicles",
    "WhyChoosedescription": "Select from hatchbacks, sedans, SUVs, and tempo travellers suitable for any group size and preference."
  },
  {
    "WhyChooseheading": "Clean and Sanitized Cabs for Your Safety",
    "WhyChoosedescription": "Our vehicles are regularly cleaned and sanitized to ensure a safe and comfortable ride in Bhosari."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Bhosari Area",
    "WhyChoosedescription": "Professional drivers who know Bhosari’s routes well, ensuring smooth and timely travel."
  },
  {
    "WhyChooseheading": "Affordable Pricing with No Hidden Charges",
    "WhyChoosedescription": "Transparent fares including fuel, tolls, and driver allowances for stress-free travel."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Easy Booking",
    "WhyChoosedescription": "Our dedicated support team is available round the clock to assist with your cab service bookings in Bhosari."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages for Short and Long Term",
    "WhyChoosedescription": "Choose hourly, daily, or long-term rental plans tailored to your specific travel requirements."
  },
  {
    "WhyChooseheading": "Easy Online Booking and Instant Confirmation",
    "WhyChoosedescription": "Book your Bhosari cab quickly and securely via our website or app with instant confirmation."
  }
]























    }

const faqData = [
    {
        question: 'Does Platinum24 Cabs offer cab services in Bhosari?',
        answer: 'Yes, Platinum24 Cabs provides reliable and efficient cab services in Bhosari for all your travel needs.',
    },
    {
        question: 'How can I book a cab service in Bhosari with Platinum24 Cabs?',
        answer: 'You can easily book your cab through our website, mobile app, or by contacting our 24x7 customer support.',
    },
    {
        question: 'What types of vehicles are available for cab service in Bhosari?',
        answer: 'We offer a variety of vehicles including hatchbacks, sedans, SUVs, and luxury cars to suit your preferences.',
    },
    {
        question: 'Can I use the cab service in Bhosari for local and outstation travel?',
        answer: 'Yes, Platinum24 Cabs offers cab services for both local trips within Bhosari and outstation travel.',
    },
    {
        question: 'Are the drivers experienced and familiar with Bhosari routes?',
        answer: 'Absolutely, our drivers are professional, licensed, and knowledgeable about Bhosari and nearby areas.',
    },
    {
        question: 'Is hourly and daily cab service available in Bhosari?',
        answer: 'Yes, we provide flexible hourly and daily cab packages tailored to your travel plans.',
    },
    {
        question: 'Are safety and hygiene protocols followed for cabs in Bhosari?',
        answer: 'All vehicles are regularly sanitized, and drivers follow strict safety measures to ensure passenger safety.',
    },
    {
        question: 'Is cab service in Bhosari available 24x7?',
        answer: 'Yes, Platinum24 Cabs offers 24x7 cab booking and services in Bhosari.',
    },
    {
        question: 'What payment options are accepted for cab bookings in Bhosari?',
        answer: 'We accept cash, digital wallets, UPI, and card payments for seamless transactions.',
    },
    {
        question: 'Can I customize pickup and drop-off locations within Bhosari for cab service?',
        answer: 'Yes, you can specify your preferred pickup and drop-off points within Bhosari as per your travel plans.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Suresh Pawar',
        feedback: 'The cab service in Bhosari by Platinum24 Cabs was punctual and very comfortable.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Kavita More',
        feedback: 'Excellent cab experience with friendly drivers and clean vehicles in Bhosari.',
        rating: 5,
    },
];




































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];







const bhosariCabServiceSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Platinum24 Cabs",
  "url": "https://www.platinum24cab.com",
  "description": "Reliable and affordable cab service in Bhosari offering local taxi, airport transfers, outstation cabs, corporate taxi, and family taxi services with driver.",
  "areaServed": {
    "@type": "Place",
    "name": "Bhosari, Pune"
  },
  "serviceType": [
    "Bhosari Cab Service",
    "Taxi Service Bhosari",
    "Bhosari Local Taxi",
    "Affordable Taxi Bhosari",
    "Bhosari Taxi with Driver",
    "Bhosari Airport Taxi",
    "Cab Rental Bhosari",
    "Bhosari Outstation Taxi",
    "Bhosari Corporate Taxi",
    "Bhosari Taxi Deals",
    "Bhosari City Taxi",
    "Bhosari Family Taxi Service",
    "Taxi Booking Online Bhosari",
    "Bhosari Taxi Service 24x7"
  ],
  "telephone": "+91-XXXXXXXXXX"
};






    return (
        <div>
<Helmet>
  <title>Cab Service in Bhosari | Affordable Taxi Service Bhosari Pune</title>
  <meta
    name="description"
    content="Reliable and affordable cab service in Bhosari offering local taxi, airport transfers, outstation cabs, corporate taxi, and family taxi services with driver."
  />
  <meta
    name="keywords"
    content="Bhosari Cab Service, Taxi Service Bhosari, Bhosari Local Taxi, Affordable Taxi Bhosari, Bhosari Taxi with Driver, Bhosari Airport Taxi, Cab Rental Bhosari, Bhosari Outstation Taxi, Bhosari Corporate Taxi, Bhosari Taxi Deals, Bhosari City Taxi, Bhosari Family Taxi Service, Taxi Booking Online Bhosari, Bhosari Taxi Service 24x7"
  />
  <script type="application/ld+json">
    {JSON.stringify(bhosariCabServiceSchema)}
  </script>
</Helmet>



            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/82.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Cabserviceinboshari;